import React, { useContext } from "react"
import { CoursesContainer, CoursesTitle } from "./styles"
import CarouselSlider from "../../slider/Slider"
import { useMediaQuery } from "react-responsive"
import ItemCard from "../../common/ItemCard/ItemCard"
import { GlobalStateContext } from "../../../context/GlobalContextProvider"
import { isBrowser } from "../../../utils/hooks/input-hook"

const MoreItems = (props) => {
  const isTablet = useMediaQuery({
    query: "(max-width: 768px)",
  })
  const isMobile = useMediaQuery({
    query: "(max-width: 565px)",
  })

  const state = useContext(GlobalStateContext)
  return (
    <CoursesContainer>
      <CoursesTitle>More Courses like this</CoursesTitle>
      <div className="courseSliderCover">
        <CarouselSlider
          slidesToShow={isMobile ? 1 : isTablet ? 2 : 3}
          slidesToScroll={isMobile ? 1 : isTablet ? 2 : 3}
          showSlideDots={false}
        >
          {state
            ? state.featured.map((item, i) => (
                <ItemCard
                  key={i}
                  slug={item.slug}
                  title={item.title}
                  category={item.category}
                  coverPhoto={item.coverPhoto}
                  courseReference={item.courseReference}
                  netFee={item.product?.netFee}
                  duration={item.duration}
                  trainingMode={item.trainingMode}
                  courseRuns={item.courseRuns}
                />
              ))
            : null}
        </CarouselSlider>
      </div>
    </CoursesContainer>
  )
}

export default MoreItems
